import { styled } from '@linaria/react'
import { ListStyled } from 'blocks/List'
import { FIXED_INDENTS } from 'vars/fixed-indents'

// The group spans the poster minus one 8px inset per side, so `flex-end` puts
// the trailing label 8px from the right edge whatever the card size.
export const SimpleLabelGroupSC = styled.div`
  position: absolute;
  z-index: 1;
  width: calc(100% - var(${FIXED_INDENTS.INDENT_40}));
  top: var(${FIXED_INDENTS.INDENT_20});
  left: var(${FIXED_INDENTS.INDENT_20});
  gap: var(${FIXED_INDENTS.INDENT_20});

  ${ListStyled} {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
`
